import { CustomForm, Priority } from '../../../common'
import { useAuth, shouldShowExperimentalFeatures } from '../../../auth'
import { ArticleRuleForm } from './ArticleRuleForm'

type PatternRule = Record<string, unknown> & { priority: string }

type EnumValues = {
  priorities: Record<string, string>
}

type Props = {
  patternType: string
  patternIdx: number
  patternRules: PatternRule[]
  enumValues: EnumValues
  handleSubmit: (values: Record<string, unknown>) => void
  isSettingWritable: boolean
}

export const ArticleRulePatternParts = ({
  patternType,
  patternIdx,
  patternRules,
  enumValues,
  handleSubmit,
  isSettingWritable
}: Props) => {
  const showExperimentalFeatures = shouldShowExperimentalFeatures(useAuth())
  const firstOtherIdx = patternRules.findIndex((rule) => rule.priority === Priority.Other)
  const getListTitle = (rule: PatternRule, ruleIdx: number) =>
    rule.priority !== Priority.Other
      ? enumValues.priorities[rule.priority]
      : `${ruleIdx - firstOtherIdx + 1}番目${enumValues.priorities[rule.priority]}`
  return (
    <>
      {patternRules.map((rule, ruleIdx) => {
        const key = `${patternType}-${patternIdx}-${ruleIdx}`
        const formSetting = {
          initialValues: rule,
          handleSubmit,
          Component: ArticleRuleForm,
          validationSchema: ArticleRuleForm.schema,
          props: {
            enumValues,
            rule,
            ruleIdx,
            listTitle: getListTitle(rule, ruleIdx),
            patternRulesLength: patternRules.length,
            isSettingWritable,
            showExperimentalFeatures,
            className: key
          }
        }
        return <CustomForm key={key} form={formSetting} />
      })}
    </>
  )
}
